import { ButtonLooks, FontIcons, StandardButton, StandardButtonProps } from '@brandfolder/react';
import { FunctionComponent, useContext } from 'react';
import styled from 'styled-components';

import { BrandguideContext } from '@context/brandguide';
import { PreviewContext } from '@context/preview';

interface HeaderPreviewProps extends Omit<StandardButtonProps, 'children'> {}

const UnstyledHeaderPreview: FunctionComponent<HeaderPreviewProps> = (props) => {
  const { brandguide } = useContext(BrandguideContext);
  const { setPreview } = useContext(PreviewContext);

  return (
    <StandardButton
      {...props}
      look={ButtonLooks.Default}
      onClick={() => setPreview(false)}
      onKeyUp={(e) => {
        if (e.key === 'Enter') {
          setPreview(false);
        }
      }}
      startIcon={FontIcons.ArrowLeft}
    >
      Edit {brandguide?.name}
    </StandardButton>
  );
};

const StyledHeaderPreview = styled(UnstyledHeaderPreview)`
  height: 40px;
  justify-self: flex-start;
  margin: 0 20px;
  max-width: 100%;
  min-height: 0;
  padding: 0 12px;

  .bf-button__standard__children {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
  }
`;

export const HeaderPreview: FunctionComponent<HeaderPreviewProps> = (props) => {
  return <StyledHeaderPreview {...props} />;
};
